/** @jsx jsx */
import { css, jsx } from '@compiled/react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import { token } from '@atlaskit/tokens';

import imgSVG from './work-item-app-skeleton.tpl.svg';
import modalImgSVG from './work-item-modal-app-skeleton.tpl.svg';

const fullPageStyles = css({
	borderTopWidth: token('space.300'),
});
const customSpacingStyles = css({
	maxWidth: '1920px',
	marginTop: token('space.0'),
	marginBottom: token('space.0'),
	borderLeftWidth: token('space.400'),
	borderRightWidth: token('space.400'),
	width: '100%',
	marginLeft: 'auto',
	marginRight: 'auto',
	/* Fix FF 2x scale bug on high res devices https://bugzilla.mozilla.org/show_bug.cgi?id=986403 */
	'@media (min--moz-device-pixel-ratio: 2)': {
		maxWidth: '840px',
		borderLeftWidth: token('space.200'),
		borderRightWidth: token('space.200'),
	},
});

export type WorkItemViewSkeletonProps = {
	isEmbedView?: boolean;
	isModalView?: boolean;
};

/**
 * Renders a placeholder for the Work Item View that adapts its layout and styling to different
 * contexts such as embedding, ensuring a consistent user experience during
 * content loading.
 */
export const WorkItemViewSkeleton = ({
	isEmbedView,
	isModalView,
}: WorkItemViewSkeletonProps): JSX.Element => {
	return (
		<div
			css={[
				customSpacingStyles,
				isEmbedView !== true && isModalView !== true ? fullPageStyles : null,
			]}
		>
			<AppSkeletonImage src={isModalView === true ? modalImgSVG : imgSVG} />
		</div>
	);
};
